var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const GhostStrike = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M20 20.2026C20 20.5979 19.609 20.8539 19.276 20.6775L17.333 19.6448L14.89 20.9432C14.749 21.0175 14.584 21.0175 14.443 20.9432L12 19.6459L9.557 20.9442C9.416 21.0186 9.251 21.0186 9.11 20.9442L6.667 19.6459L4.724 20.6786C4.391 20.8539 4 20.5979 4 20.2026V16C4 11.5687 4 7.88595 5.58497 5.58497M20 16C20 8.39869 20 3 12 3C10.2201 3 8.83628 3.26723 7.76029 3.76648M10.5 13H13M14 9V10M3 3L5.58497 5.58497M21 21L5.58497 5.58497M10 9V10", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
